import StaticDocumentDetail from './StaticDocumentDetail';

export default StaticDocumentDetail;



// WEBPACK FOOTER //
// ./src/scenes/StaticDocuments/StaticDocumentDetail/index.ts